import * as React from 'react';
import { ActionType } from '@src/framework/editor/src/js/constants/common-action-type';
import { Controller, IDynamicLoader, Loader, MainMenu, Menu, Toolbar } from '@tencent/workbench';
import { MENU_CONFIGS, TOOLBAR_ITEMS, config } from './config';
import { IDeleteCommentFeature } from './delete-comment-interface';

@Controller({
    toolbarItems: TOOLBAR_ITEMS,
    menuItems: MENU_CONFIGS,
})
export class DeleteCommentController {
    public constructor(@Loader(IDeleteCommentFeature) private loader: IDynamicLoader<IDeleteCommentFeature>) {
    }

    private get feature() {
        return this.loader.instance!;
    }

    @Toolbar(config.id, 'dropdownContent')
    public insertDropdown() {
        return <MainMenu align="left" name={config.id} mode="menu" itemStyle={{ width: 166 }} />;
    }

    @Menu(ActionType.DELETE_COMMENT_GROUP, 'onClick')
    public handleDeleteCommentGroupClick() {
        this.feature.handleDeleteCommentGroupClick();
    }

    @Menu(ActionType.DELETE_PAGE_COMMENT, 'onClick')
    public handleDeletePageCommentClick() {
        this.feature.handleDeletePageCommentClick();
    }

    @Menu(ActionType.DELETE_ALL_COMMENT, 'onClick')
    public handleDeleteAllCommentClick() {
        this.feature.handleDeleteAllCommentClick();
    }

    @Toolbar(config.id, 'shouldDisabled')
    public shouldDisabled() {
        return this.feature.shouldDisabled(config.id);
    }

    @Menu(ActionType.DELETE_COMMENT_GROUP, 'shouldDisabled')
    public shouldDeleteCommentGroupDisabled() {
        return this.feature.shouldDeleteCommentGroupDisabled();
    }

    @Menu(ActionType.DELETE_PAGE_COMMENT, 'shouldDisabled')
    public shouldDeletePageCommentGroupDisabled() {
        return !window.clientVars.isOwner || this.feature.shouldDeletePageCommentGroupDisabled();
    }

    @Menu(ActionType.DELETE_ALL_COMMENT, 'shouldDisabled')
    public shouldHide() {
        return !window.clientVars.isOwner;
    }
}
